import { render, staticRenderFns } from "./NotesHeader.vue?vue&type=template&id=05deb2b0&scoped=true"
import script from "./NotesHeader.vue?vue&type=script&lang=js"
export * from "./NotesHeader.vue?vue&type=script&lang=js"
import style0 from "./NotesHeader.vue?vue&type=style&index=0&id=05deb2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05deb2b0",
  null
  
)

export default component.exports